import React, { useEffect, useState } from "react";
import { Input, Button, Form } from "antd";
import ApiClient from "../../../helpers/ApiClient";

const INVALID_PAN_MESSAGE =
  "Wrong Pan Number, Please check and put actual PAN Number.";

const HotelTicketRoomPan = ({
  referenceNo = "",
  guestFirstName = "",
  guestLastName = "",
  onVerified,
  appliedPan = "",
  fieldError = "",
  onPanInputChange = () => {},
}) => {
  const [panNumber, setPanNumber] = useState(appliedPan);
  const [loading, setLoading] = useState(false);
  const [verifyError, setVerifyError] = useState("");

  useEffect(() => {
    setPanNumber(appliedPan || "");
  }, [appliedPan]);

  const displayError = fieldError || verifyError;

  const handleApply = () => {
    const pan = String(panNumber).trim().toUpperCase();
    setVerifyError("");
    if (pan.length !== 10 || !/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(pan)) {
      setVerifyError("Please verify Pan Number");
      return;
    }

    setLoading(true);
    const payload = { pan_number: pan };
    if (referenceNo) {
      payload.referenceNo = referenceNo;
    }
    if (guestFirstName) {
      payload.guestFirstName = guestFirstName;
    }
    if (guestLastName) {
      payload.guestLastName = guestLastName;
    }

    ApiClient.post("hotels-v2/verificationPan", payload)
      .then((res) => {
        setLoading(false);
        if (res.status === 200 && res.data?.[0]?.pan_number) {
          setVerifyError("");
          onVerified?.(res.data[0].pan_number, res.data[0]);
        } else {
          setVerifyError(res?.message || INVALID_PAN_MESSAGE);
        }
      })
      .catch(() => {
        setLoading(false);
        setVerifyError(INVALID_PAN_MESSAGE);
      });
  };

  return (
    <Form.Item
      label="Pan Number"
      required
      validateStatus={displayError ? "error" : ""}
      help={displayError || null}
      className="review-pan-form-item"
    >
      <div className="hotel-review-pan-inline">
        <Input
          className="hotel-review-pan-entry-input"
          placeholder="Enter Your Pan Number"
          autoComplete="off"
          maxLength={10}
          value={panNumber}
          status={displayError ? "error" : ""}
          onChange={(e) => {
            const next = e.target.value.toUpperCase();
            setPanNumber(next);
            setVerifyError("");
            onPanInputChange();
          }}
        />
        <span className="hotel-review-pan-colon">:</span>
        <Button type="primary" loading={loading} onClick={handleApply}>
          Apply
        </Button>
      </div>
    </Form.Item>
  );
};

export default HotelTicketRoomPan;
